import {
  numberValidation,
  floatValidation,
  urlValidation,
  asinValidation,
} from '../../utils/formikValidations';
import * as yup from 'yup';

export default function getProductValidation({ isAmazonSeller }) {
  return yup.object({
    product: yup.string().required('Product is required'),
    shipments: numberValidation,
    msrp: floatValidation,
    url: isAmazonSeller ? null : urlValidation,
    asin: isAmazonSeller ? asinValidation(isAmazonSeller) : null,
  });
}
